import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { SectionLabel } from "@/components/Reveal";
import { CLIENTS } from "@/data/content";

const Marquee = ({ bare = false }) => {
  const { t } = useLang();
  const row = [...CLIENTS, ...CLIENTS];

  return (
    <section
      data-testid="clients-marquee"
      className={`relative bg-forest-deep text-cream overflow-hidden ${bare ? "pt-4 pb-16 sm:pb-20" : "pt-24 sm:pt-32 pb-8"}`}
    >
      {!bare && (
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14 mb-12">
          <SectionLabel dark>{t("clients.label")}</SectionLabel>
          <h2 className="font-display font-light tracking-tight leading-[1.05] text-3xl sm:text-4xl lg:text-5xl mt-6 max-w-3xl">
            {t("clients.title")}
          </h2>
        </div>
      )}

      <div className="relative select-none">
        {/* edge fades */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 sm:w-40 bg-gradient-to-r from-forest-deep to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 sm:w-40 bg-gradient-to-l from-forest-deep to-transparent z-10" />

        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {row.map((name, i) => (
            <div key={i} className="flex items-center shrink-0">
              <span className="font-display text-4xl sm:text-6xl lg:text-7xl font-light text-cream/85 px-8 sm:px-12 whitespace-nowrap hover:text-gold transition-colors duration-300">
                {name}
              </span>
              <span className="text-gold text-2xl sm:text-3xl" aria-hidden>◆</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
